<template>
  <div class="user-container">
    <div class="table-field">
      <el-row>
        <el-button class type="primary" @click="editeStatus = false">新增</el-button>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      :row-style="{height:'30px'}"
      :cell-style="{padding:'5px 0'}"
      style="width: 100%"
      height="580px"
      :border="true"
      :header-cell-style="{background: '#f2f2f2'}"
    >
      <el-table-column prop="name" label="菜单名称" width="150"></el-table-column>
      <el-table-column label="菜单图标" width="100">
        <template slot-scope="scope">
          <el-image
            style="width: 75px; height: 70px"
            :src="scope.row.icon"
            :preview-src-list="[scope.row.icon]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="关联类型" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.type === `1` ? `文章类型`: `指定文章` }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === `0`" type="danger">未启用</el-tag>
          <el-tag v-if="scope.row.status === `1`" type="success">已启用</el-tag>
          <el-tag v-if="scope.row.status === `2`" type="warning">已禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="linkName" label="关联名称"></el-table-column>
      <el-table-column fixed="right" width="250" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="handleClickPush(scope.row.id)"
            type="success"
            size="mini"
            icon="el-icon-caret-right"
            v-if="scope.row.status   !== `1` "
          >启用</el-button>
          <el-button type="primary" icon="el-icon-edit" @click="handlEidt(scope.row)" size="mini">编辑</el-button>
          <el-button
            type="danger"
            icon="el-icon-edit"
            @click="handlDelete(scope.row.id)"
            v-if="scope.row.status === `1`"
            size="mini"
          >禁用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title=" (editeStatus ? '修改':`新增`) + `公众号菜单`"
      :width="`450px`"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="mpMenuDTO">
        <el-form-item label="菜单名称">
          <el-input style="width:300px;" v-model="mpMenuDTO.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标">
          <el-upload
            action="/admin/file/upload/image"
            :headers="token"
            :on-success="iconUpload"
            multiple
            drag
            :limit="fileLimit"
            list-type="picture"
            :file-list="iconList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="关联类型">
          <el-radio-group style="width:300px;" v-model="mpMenuDTO.type">
            <el-radio label="1" :value="`1`">文章类型</el-radio>
            <el-radio label="2" :value="`2`">指定文章</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="showTypeSelect" label="文章类型">
          <el-select style="width:300px;" v-model="mpMenuDTO.linkId" placeholder="请选择">
            <el-option
              v-for="item in artTypleVO"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="showArticleSelect" label="指定文章">
          <el-select
            filterable
            :filter-method="searchArticle"
            style="width:300px;"
            v-model="mpMenuDTO.linkId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in articleVO"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddMpMenu">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  mpMenuList,
  activeMpMenu,
  forbidMpMenu,
  artTyple,
  newsList,
  addMpMenu,
  editMpMenu
} from "@/axios/api";
import QS from "qs";
export default {
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      token: {
        access_token: ""
      },
      mpMenuDTO: {
        name: "",
        type: "",
        icon: "",
        linkId: "4",
        id: ""
      },
      artTypleVO: [],
      articleVO: [],
      showTypeSelect: false,
      articleDTO: {
        page: 1,
        limit: 10,
        title: ""
      },
      showArticleSelect: false,
      editeStatus: "",
      fileLimit: 1,
      iconList: []
    };
  },
  methods: {
    handleEditMpMenu() {
      editMpMenu(this.mpMenuDTO).then(res => {
        if (res.status === 200) {
          this.$message.success("修改成功");
          this.tableData = res.data;
        }
      });
    },
    searchArticle(value) {
      if (value !== "") {
        this.articleDTO.title = value;
        newsList(this.articleDTO).then(res => {
          if (res.status === 200) {
            this.articleVO = res.records;
            if (this.mpMenuDTO.linkId !== "") {
              this.mpMenuDTO.linkId -= 1;
              this.mpMenuDTO.linkId += 1;
            }
          }
        });
      }
    },
    getArtTyple() {
      artTyple().then(res => {
        if (res.status === 200) {
          this.artTypleVO = res.data;
          if (this.mpMenuDTO.linkId !== "") {
            this.mpMenuDTO.linkId -= 1;
            this.mpMenuDTO.linkId += 1;
          }
        }
      });
    },
    iconUpload(res) {
      if (res.status === 200) {
        this.$message.success("上传成功");
        this.mpMenuDTO.icon = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handlDelete(id) {
      forbidMpMenu(id).then(res => {
        if (res.status === 200) {
          this.$message.success("禁用成功");
          this.getMpMenuList();
        }
      });
    },
    handlEidt(object) {
      this.editeStatus = true;
      this.mpMenuDTO.name = object.name;
      this.mpMenuDTO.icon = object.icon;
      this.mpMenuDTO.type = object.type;
      this.mpMenuDTO.linkId = object.linkId;
      this.mpMenuDTO.id = object.id;
      this.iconList = [];
      this.iconList.push({
        name: object.icon.split("/")[object.icon.split("/").length - 1],
        url: object.icon
      });
      if (object.type === `2`) {
        this.searchArticle(object.linkName);
      }
      this.dialogFormVisible = true;
    },
    handleClickPush(id) {
      activeMpMenu(id).then(res => {
        if (res.status === 200) {
          this.$message.success("启用成功");
          this.getMpMenuList();
        }
      });
    },
    hadnleAddMpMenu() {
      addMpMenu(this.mpMenuDTO).then(res => {
        if (res.status === 200) {
          this.$message.success("新增成功");
          this.dialogFormVisible = false;
          this.getMpMenuList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAddMpMenu() {
      if (this.editeStatus) this.handleEditMpMenu();
      if (!this.editeStatus) this.hadnleAddMpMenu();
    },
    getMpMenuList() {
      mpMenuList().then(res => {
        this.tableData = res.data;
        this.total = res.total;
      });
    }
  },
  mounted() {
    this.getMpMenuList();
    let user = QS.parse(localStorage.getItem("admin"));
    this.token.access_token = user.token;
  },
  watch: {
    "mpMenuDTO.type": function(v) {
      if (v === `1`) {
        this.getArtTyple();
        this.showTypeSelect = true;
        this.showArticleSelect = false;
      }
      if (v === `2`) {
        this.showTypeSelect = false;
        this.showArticleSelect = true;
      }
    },
    editeStatus(n) {
      if (!n) {
        this.mpMenuDTO.name = "";
        this.mpMenuDTO.icon = "";
        this.mpMenuDTO.type = "";
        this.mpMenuDTO.linkId = "";
        this.mpMenuDTO.id = "";
        this.iconList = [];
        this.dialogFormVisible = true;
      }
    }
  }
};
</script>

<style scoped>
.table-field .el-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-field {
  width: 100%;
  height: 60px;
  border: 1px solid #ebebeb;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.user-container {
  width: 100%;
  height: auto;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/menu/MpMenu.vue